// extracted by mini-css-extract-plugin
export default {"toggles":"styles_toggles__ehb-Y","toggle":"styles_toggle__mT1Bn","left":"styles_left__YJl8w","icon":"styles_icon__5QSFs","label":"styles_label__jCxRk","right":"styles_right__ZIvcJ"};